import React from "react";
import "./_index.scss";

const ComponentNotificationBulb = React.memo(function ComponentNotificationBulb(
  props
) {
  const thisCount = (num) => {
    try {
      let c = parseInt(num);
      if (Number.isNaN(c)) {
        return { count: "0", plus: "", numeric: 0 };
      }
      return {
        count: c > 99 ? "99" : String(c),
        plus: c > 99 ? "+" : "",
        numeric: c,
      };
    } catch (e) {
      return {
        count: "0",
        plus: "",
        numeric: 0,
      };
    }
  };
  const parsed = thisCount(props.count);
  const count = parsed.count;
  const plus = parsed.plus;
  const customColor = props.color || "#9F1A20"; // Default to brandRed if no color provided
  const label = props.label ? String(props.label).trim() : "";

  // Labeled badge e.g. "12 PASSED" for Participant Certification & Evaluation
  if (label) {
    if (parsed.numeric <= 0 && !props.showZero) {
      return <></>;
    }
    return (
      <div
        className="nb-labeled d-inline-flex align-items-center"
        style={{
          backgroundColor: customColor,
          color: "#fff",
          borderRadius: "999px",
          padding: "0.15rem 0.55rem",
          fontSize: "0.7rem",
          fontWeight: 700,
          letterSpacing: "0.02em",
          lineHeight: 1.2,
          whiteSpace: "nowrap",
        }}
        role="status"
        aria-label={`${parsed.numeric}${plus} ${label}`}
      >
        <span>
          {parsed.numeric}
          {plus} {label.toUpperCase()}
        </span>
      </div>
    );
  }

  return (
    <>
      {parseInt(count) >= 0 ? (
        <div className="nb-c">
          <div className="nb-i">
            <svg
              version="1.2"
              baseProfile="tiny"
              id="Layer_1"
              xmlns="http://www.w3.org/2000/svg"
              x="0px"
              y="0px"
              viewBox="0 0 92 92"
              style={{ fill: customColor }}
            >
              <path d="M47,92h-2C20.2,92,0,71.7,0,47v-2C0,20.1,20.1,0,45,0h47v47C92,71.9,71.9,92,47,92z" />
            </svg>
          </div>
          <div className="nb-t d-flex justify-content-center align-items-center">
            <svg viewBox="0 0 92 92" xmlns="http://www.w3.org/2000/svg">
              <text fontSize="70" textAnchor="middle" x="46" y="68">
                {count}
              </text>
            </svg>
          </div>
          {plus === "+" ? <div className="nb-p" style={{ color: customColor }}>+</div> : <></>}
        </div>
      ) : (
        <></>
      )}
    </>
  );
});

export default ComponentNotificationBulb;
